var _path, _circle, _rect, _circle2, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPhemeLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 456,
    height: 470,
    viewBox: "0 0 456 470",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M228.5 107C307.201 107 371 167.442 371 242C371 316.558 307.201 377 228.5 377C149.799 377 86 316.558 86 242C86 167.442 149.799 107 228.5 107ZM228 142C170.01 142 123 186.548 123 241.5C123 296.452 170.01 341 228 341C285.99 341 333 296.452 333 241.5C333 186.548 285.99 142 228 142Z",
    fill: "#2D2C2F"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 248,
    cy: 243,
    r: 35,
    fill: "#00B1D2"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 206.35,
    y: 66.35,
    width: 44.3,
    height: 352.3,
    rx: 1.65,
    fill: "#EEE2DD",
    stroke: "#2D2C2F",
    strokeWidth: 0.7
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.44,
    cx: 250,
    cy: 243,
    r: 34.95,
    fill: "#00B1D2",
    stroke: "#2D2C2F",
    strokeWidth: 0.1
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M250.35 375.382C241.623 377.555 235.059 378.754 228.499 378.812C221.939 378.869 215.375 377.785 206.65 375.385V339.698C221.43 344.027 231.889 343.42 250.35 339.188V375.382Z",
    stroke: "#D4367A",
    strokeWidth: 0.3
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M250.5 109.309C241.791 107.068 235.237 105.817 228.677 105.708C222.118 105.6 215.545 106.633 206.803 108.965L206.524 144.65C221.337 140.437 231.791 141.126 250.218 145.502L250.5 109.309Z",
    stroke: "#D4367A",
    strokeWidth: 0.3
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M358.961 9.76367C422.939 91.5339 454.93 164.309 455.081 237.65C455.232 311.001 423.536 385.013 359.934 469.255L338.157 448.931C395.722 366.726 425.013 302.814 425.171 239.261C425.329 175.701 396.349 112.608 337.649 32.043L358.961 9.76367Z",
    fill: "#00B1D2",
    stroke: "#58C9D4"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M96.6208 0.763672C32.6431 82.5339 0.652093 155.309 0.500641 228.65C0.349265 302.001 32.0455 376.013 95.6481 460.255L117.424 439.931C59.8592 357.726 30.5688 293.814 30.4108 230.261C30.2528 166.701 59.2323 103.608 117.932 23.043L96.6208 0.763672Z",
    fill: "#00B1D2",
    stroke: "#58C9D4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhemeLogo);
export default __webpack_public_path__ + "static/media/pheme-logo.0c04fe27bcc6ad3b2aa72755574e2954.svg";
export { ForwardRef as ReactComponent };